<script>
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import { useNewEmail } from "./utils";

  import { todoPanelStore } from "../stores";

  $: disabled = !$todoPanelStore.newEmail || $todoPanelStore.invalidEmail;

  // Reset invalidEmail when email changes
  $: if ($todoPanelStore.newEmail !== $todoPanelStore.invalidEmail) {
    $todoPanelStore.invalidEmail = null;
  }

  const onclick = async () => {
    if (disabled) return;

    await useNewEmail();
  };
</script>

<ButtonWithTooltip
  kind="primary"
  leadingIcon="fa-solid fa-envelope"
  class="flex-1 {disabled ? 'disabled' : ''}"
  {onclick}
  placement="top"
  size="large"
>
  <span slot="tooltip">
    {#if disabled}
      Add email address above to use new email.
    {:else}
      Add contact to campaign first step with new email.
    {/if}
  </span>
  Use new email
</ButtonWithTooltip>
